import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-tour-dialog',
  templateUrl: './tour-dialog.component.html',
  styleUrls: ['./tour-dialog.component.scss'],
})
export class TourDialogComponent {
  tourStep = 1;

  nextStep() {
    this.tourStep += 1;
  }

  prevStep() {
    this.tourStep -= 1;
  }
}
